import * as actions from "./broker.actions";
import * as api from "./broker.api";
import { BASE_PATH_ENTITY, ENTITY, REDUCER_KEY } from "./broker.constants";
import * as hooks from "./broker.hooks";
import * as promises from "./broker.promises";
import reducer from "./broker.reducer";
import { saga } from "./broker.saga";
import * as selectors from "./broker.selectors";
import * as utils from "./broker.utils";
export * from "./broker.types";
export var REDUCER_KEY_BROKER = REDUCER_KEY;
export var brokerModule = {
    entity: ENTITY,
    reducerKey: REDUCER_KEY,
    basePathEntity: BASE_PATH_ENTITY,
    reducerState: {},
    actions: actions,
    api: api,
    hooks: hooks,
    promises: promises,
    reducer: reducer,
    saga: saga,
    selectors: selectors,
    utils: utils,
};
